<template>
  <div class="frame21_body">
    <div class="frame21">
      <div class="frame21_top">
        北向资金持股
        <img
          src="../../../../public/img/shares_Info/close.png"
          alt=""
          @click="frame21_close"
        />
      </div>
      <div class="frame21_content">
        <div class="frame21_content_title">北向资金持股</div>
        <div class="frame21_content_text">
          【释义】：北上资金持股是指境外机构通过香港交易所直接购买上海交易所和深圳交易所符合条件的股票。一般而言，北向资金持股比例越高，表示境外机构越看好该股票。
        </div>
        <div class="frame21_content_text">【算法】 沪股通：占流通A股数的百分比； 深股通：占全部A股数的百分比。 注：该数值为香港联交所披露易公布值。</div>
        <div class="frame21_content_text">【单位】：%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    frame21_close() {
      this.$emit("frame21_close");
    },
  },
};
</script>

<style scoped>
.frame21_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame21 {
  width: 448px;
  /* height: 920px; */
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame21_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame21_content {
  margin-top: 28px;
}
.frame21_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame21_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame21_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>